import _trimEnd from 'lodash/trimEnd';

module.exports = {
  path: ':id',
  indexRoute: {
    onEnter: (nextState, replace) => replace(`${_trimEnd(nextState.location.pathname, '/')}/groups`),
  },
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/groups'),
        require('./routes/partners'),
        require('./routes/slugs'),
        require('./routes/serviceFeeRules'),
        require('./routes/settings'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/WorkspaceShow'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/routes/show/index.js